// removed by extract-text-webpack-plugin
module.exports = {"footer":"footer__14P9B","text":"text__ltW01","rightMostIcons":"rightMostIcons__2dPLf","thirdColumn":"thirdColumn__WLAsm","tooltip":"tooltip__23XHt","tooltiptext":"tooltiptext__RPVYE","displayLine":"displayLine__1AeYf","QRcodeImage":"QRcodeImage__2ttfZ"};


//////////////////
// WEBPACK FOOTER
// ./components/footer/style.css
// module id = ZMjw
// module chunks = 3